module.exports = __webpack_public_path__ + "media/images/kantar/monster_panel_logo-e8f960a782cdb9a086a4a2df9cbc92ce.png";